







































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

import { IQuoteServiceTemplate } from '@/models';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import QuoteTemplateNoteTooltipIcon from '../common/QuoteTemplateNoteTooltipIcon.vue';

export default Vue.extend({
  components: { ErrorAlert, QuoteTemplateNoteTooltipIcon },
  props: {
    errorMessage: String,
    detailErrorMessage: String
  },

  data: () => ({
    headers: [
      {
        text: '',
        align: 'start',
        width: 30,
        sortable: false,
        value: 'note'
      },
      {
        text: '#',
        align: 'center',
        width: 50,
        sortable: false,
        value: 'index'
      },
      {
        text: 'Title',
        align: 'start',
        sortable: false,
        value: 'title'
      },
      {
        sortable: false,
        align: 'end',
        value: 'actions'
      }
    ],
    loading: false
  }),

  computed: {
    quoteServiceTemplates: get<IQuoteServiceTemplate[]>(
      'quoteTemplate/getQuoteServiceTemplates'
    )
  },

  mounted() {
    this.clearAllErrors();

    this.loading = true;
    this.fetchQuoteServiceTemplates()
      .catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.$emit('update:detailErrorMessage', error.response.data.detail);
          }
        }
        this.$emit('update:errorMessage', ErrorManager.extractApiError(error));
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    ...mapActions({
      fetchQuoteServiceTemplates: 'quoteTemplate/fetchQuoteServiceTemplates'
    }),

    clearAllErrors(): void {
      this.$emit('clearAllErrors');
    }
  }
});
